import { render, staticRenderFns } from "./HeaderMegaMenu.vue?vue&type=template&id=3d2fddab"
import script from "./HeaderMegaMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMegaMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports